<template>
  <div class="fourCards">
    <div class="container-flued">
      <div class="container">
        <div class="row">
          <div class="col-lg-1"></div>
          <div class="col-lg-10">
            <div class="row">
              <div class="col-lg-4">
                <div class="zCard" @click="goto('LifeInsurance')">
                  <img src="@/assets/p1.png" />
                  <h5>Cold Calling</h5>
                  <p>Financial protection for the safety of your loved ones.</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="zCard">
                  <img src="@/assets/p2.png" />
                  <h5>Appointment Setting</h5>
                  <p>
                    We'll get you the finest deal in your region. Learn how to
                    save hundreds of dollars per year.
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="zCard">
                  <img src="@/assets/p3.png" />
                  <h5>Call Center Outsourcing</h5>
                  <p>
                    Organize all of your necessities for later life in one safe
                    place with Us.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-1"></div>
        </div>
        <!--/row-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FourCards',
  props: {
    msg: String,
  },
  methods: {
    goto(selectedName) {
      this.$router.push({ name: selectedName, replace: true });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fourCards {
  background: #e8e8e8;
  padding-bottom: 40px;
  padding-top: 40px;
  h4 {
    font-family: Inter;
    color: #292341;
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  h5 {
    color: #ffc93c;
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    margin-bottom: 30px;
  }
  .zCard {
    margin: 20px;
    border-radius: 8px;
    border: 1px solid rgba(0, 52, 120, 0.26);
    background: #292341;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    box-sizing: border-box;
    cursor: pointer;
    min-height: 350px;
    img {
      display: inline-block;
      height: 70px;
    }
    h5 {
      color: #fff;
      font-family: Inter;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: 20px;
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    p {
      color: #fff;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.72px;
      text-transform: capitalize;
      margin-top: 10px;
      height: 90px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    a {
      border-radius: 8px;
      border: 2px solid #ffc93c;
      color: #fff;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding: 4px 12px;
      text-decoration: none;
    }
  }
}
@media screen and (max-width: 992px) {
  .fourCards {
    h4 {
      font-size: 32px;
    }
  }
}
</style>
